var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"title":'选择推荐商品',"visible":_vm.dialogVisible,"width":"1000px","top":"5vh","close-on-click-modal":false,"append-to-body":_vm.appendToBody},on:{"update:visible":function($event){_vm.dialogVisible=$event},"open":_vm.open}},[_c('activityCategorySelectGoods',{ref:"selectGoodsRef",on:{"submit":_vm.handleSubmit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }